<template>
  <div class="ov">
    <div style="padding:0 20px 15px;">
      <template v-for="(item, index) in product" >
        <div style="font-weight:bold;font-size:12px; text-align:left;padding:5px 10px 5px 10px;margin-top:8px;border-bottom:1px dotted #fff;">{{item.username}}&nbsp;{{item.datetime}}</div>
        <div style="text-align:left;line-height:20px;padding:5px 7px 0 7px;">{{item.beizhu}}</div>
        <fieldset style='margin:0 7px 3px 7px;padding:5px 10px;text-align:left;border:1px dotted #fff;color:#FEFFA7;' v-if="item.reply"><legend style='background:#965229;color:#FEFFA7;font-weight:bold;margin-bottom:3px;'>四海回复</legend>{{item.reply}}</fieldset>
      </template>
    </div>
  </div>
</template>

<script>
import finder from '../mock/finder.json'

export default {
  name: 'suiyue',
  data () {
    return {
      finder
    }
  },
  computed: {
    product () {
      let product = this.finder.finder_message.filter(item => item.beizhu).reverse() || []
      return product
    }
  }
}
</script>
